export const MAX_END_SESSION_TIME = '15:00:00'
export const MAX_END_SESSION_TIME_WITH_PROLONGATION = '16:00:00'
export const MIN_START_SESSION_TIME = '10:00:00'
export const MAX_START_SESSION_TIME = '15:00:00'
export const MAX_FILES_COUNT_PER_REQUEST = 10
export const MIN_WARRANRY_PERCENT = 0.05
export const MAIN_ADMIN_NAME = 'ADMINISTRATOR'
export const ADMIN_INN = '7840389730'
export const VAT_TEXT = 'с учетом НДС, {0}'
export const RUSSIAN_COUNTRY_ID = 180
export const MAX_PREMIUM_STEP_COUNT = 20
export const WARNING_PREMIUM_STEP_COUNT = 5
export const MAX_FIX_PREMIUM_VALUE = 99999999999.99
export const MIN_FIX_PREMIUM_VALUE = 1.00
export const MAX_DIFF_PREMIUM_VALUE = 999.99
export const MIN_DIFF_PREMIUM_VALUE = -999.99

export const LOT_TYPES = Object.freeze({
  AUCTION: 'auction',
  REQUEST_OFFERS: 'requestOffers',
  REQUEST_OFFERS_DIVISIBLE_VOLUME: 'requestOffersDivisibleVolume'
})

export const THEME_TYPES = Object.freeze({
  LIGHT: 'light',
  DARK: 'dark'
})

export const SESSION_TYPES = Object.freeze({
  PRIVATE_OFFERS: 'privateOffers',
  PUBLIC_OFFERS: 'publicOffers',
  PUBLIC_OFFERS_DIVISIBLE_VOLUME: 'publicOffersDivisibleVolume'
})

export const SESSION_STATUSES = Object.freeze({
  DRAFT: 'draft',
  REGISTERED: 'registered'
})

export const STATIC_FILE_TYPES = Object.freeze({
  PICTURE: 'picture',
  DOC: 'doc'
})

export const ORGANIZATION_TYPES = Object.freeze({
  LEGAL: 'legal',
  INDIVIDUAL: 'individual'
})

export const PARTICIPANT_TYPES = Object.freeze({
  UNKNOWN: 'unknown',
  ADMINISTRATOR: 'administrator',
  ORGPART: 'orgPart',
  NONE: 'none'
})

export const PREMIUM_TYPES = Object.freeze({
  FIX: 'fix'
})

export const PROXY_TYPES = Object.freeze({
  USER_PROXY: 'userProxy',
  ORGANIZATION_PROXY: 'organizationProxy'
})

export const USER_TYPES = Object.freeze({
  UNREGISTERED: 'unregistered',
  REGISTERED: 'registered'
})

export const LOT_STATUSES = Object.freeze({
  REGISTERED: 'registered',
  DRAFT: 'draft',
  FINISHED: 'finished',
  RECALLED: 'recalled'
})

export const SUBSCRIPTION_TYPES = Object.freeze({
  FULL: 'full',
  PARTIAL: 'partial',
  NONE: 'none'
})

export const DOCUMENT_STATUSES = Object.freeze({
  INPROCESS: 'inprocess',
  APPROVED: 'approved',
  DISABLED: 'disabled'
})

export const REQUEST_STATUSES = Object.freeze({
  CREATED: 'created',
  INPROCESS: 'inprocess',
  REJECTED: 'rejected',
  APPROVED: 'approved'
})

export const ORG_REQUEST_STATUSES = Object.freeze({
  CREATED: 'created',
  INPROCESS: 'inprocess',
  REJECTED: 'rejected',
  APPROVED: 'approved'
})

export const LOT_REQUEST_STATUSES = Object.freeze({
  CREATED: 'created',
  INPROCESS: 'inprocess',
  REJECTED: 'rejected',
  APPROVED: 'approved'
})

export const ORGANIZATION_TABS = Object.freeze({
  GENERAL_INFO: 'generalInfo',
  USERS: 'users',
  BANK_ACCOUNTS: 'bankAccounts',
  CONTRACT: 'contract',
  DOCUMENTS: 'documents'
})

export const IDENTITY_REQUEST_TYPES = Object.freeze({
  INDIVIDUAL_ORGANIZATION: 'individualOrganization',
  LEGAL_ORGANIZATION: 'legalOrganization',
  PARTICIPANT_INDIVIDUAL_ORGANIZATION: 'participantIndividualOrganization',
  PARTICIPANT_LEGAL_ORGANIZATION: 'participantlegalOrganization',
  ORGANIZATION_AGENT: 'organizationAgent',
  ORGANIZATION_TOP_MANAGER: 'organizationTopManager',
  INDIVIDUAL_ORGANIZATION_AS_EIO: 'individualOrganizationAsEIO',
  LEGAL_ORGANIZATION_AS_EIO: 'legalOrganizationAsEIO',
  PARTICIPANT_LEGAL_ORGANIZATION_AS_EIO: 'participantLegalOrganizationAsEIO',
  PARTICIPANT_INDIVIDUAL_ORGANIZATION_AS_EIO: 'participantIndividualOrganizationAsEIO'

})

export const IDENTITY_DOCUMENT_GROUPS = Object.freeze({
  LEGAL_ORGANIZATION_DOCUMENTS: 'legalOrganizationDocuments',
  INDIVIDUAL_ORGANIZATION_DOCUMENTS: 'individualOrganizationDocuments',
  PARTICIPANT_LEGAL_ORGANIZATION_DOCUMENTS: 'participantLegalOrganizationDocuments',
  PARTICIPANT_INDIVIDUAL_ORGANIZATION_DOCUMENTS: 'participantIndividualOrganizationDocuments',
  ORGANIZATION_AGENT_DOCUMENTS: 'organizationAgentDocuments',
  ORGANIZATION_TOP_MANAGER_DOCUMENTS: 'organizationTopManagerDocuments',
  LEGAL_ORGANIZATION_DOCUMENTS_AS_EIO: 'legalOrganizationDocumentsAsEIO',
  INDIVIDUAL_ORGANIZATION_DOCUMENTS_AS_EIO: 'individualOrganizationDocumentsAsEIO',
  PARTICIPANT_LEGAL_ORGANIZATION_DOCUMENTSAS_EIO: 'participantLegalOrganizationDocumentsAsEIO',
  PARTICIPANT_INDIVIDUAL_ORGANIZATION_DOCUMENTS_AS_EIO: 'participantIndividualOrganizationDocumentsAsEIO'

})

export const BUSINESS_DOCUMENT_GROUPS = Object.freeze({
  OFFER_CLIENT_PROXY: 'clientProxy',
  CLARIFICATION: 'clarification'
})

export const USER_TABS = Object.freeze({
  USER_INFO: 'userInfo',
  PROXIES: 'proxies',
  SUBSCRIPTIONS: 'subscriptions'
})

export const BANK_ACCOUNT_TYPES = Object.freeze({
  CREDIT: 'credit',
  FEDERAL: 'federal'
})

export const PAYMENT_PURPOSE_TYPES = Object.freeze({
  ACCESS_PAYMENT: 'accessPayment',
  TRANSFER_SECURITY_DEPOSIT: 'transferSecurityDeposit',
  PAYMENT_FOR_INFORMATION: 'paymentForInformation',
  PAYMENT_OF_PURCHASE: 'paymentOfPurchase',
  PENALTY_TRANSFER: 'penaltyTransfer'
})

export const DOCUMENT_PERSON_IDENTITY_TYPES = Object.freeze({
  PASSPORT: 'passport',
  BIRTH_CERTIFICATE: 'birthCertificate',
  INTERNATIONAL_PASSPORT: 'internationalPassport',
  MILITARY_ID: 'militaryId',
  RUSSIAN_TEMPORARY_IDENTITY_CARD: 'russianTemporaryIdentityCard',
  SAILOR_ID: 'sailorId',
  RESIDENCE_PERMIT: 'residencePermit'
})

export const PRIVACY_TYPES = Object.freeze({
  PERSONAL: 'personal',
  ALL: 'all'
})

export const DICTIONARY_TYPES = Object.freeze({
  BIK: 'bik',
  COUNTRIES: 'countries',
  PRODUCT_SECTIONS: 'productSections'
})

export const LOT_TABS = Object.freeze({
  GENERAL_INFO: 'generalInfo',
  LOT_DOCUMENTS: 'lotDocuments',
  TRADE_PROCESS_DOCUMENTATION: 'tradeProcessDocumentation',
  TRADE_PROCESS: 'tradeProcess',
  ORDERS: 'orders',
  TRADE_RESULTS: 'tradeResults',
  LOT_REQUESTS: 'lotRequests'
  // REGISTERS: 'registers'
})

export const DOCUMENT_TYPES = Object.freeze({
  REGISTRY: 'registry',
  CONTRACT: 'contract',
  CLARIFICATION: 'clarification',
  OFFER_CLIENT_PROXY: 'clientProxy',
  NOTES: 'notes',
  NOTICE: 'notice',
  OTHER_DOCUMENTS: 'otherDocuments',
  DOCUMENTATION: 'documentation',
  OFFERER_NOTIFICATION: 'offererNotification',
  STATEMENT: 'statement',
  USER_PROXY: 'userProxy',
  USER_STATEMENT: 'userStatement',
  ORGANIZATION_PROXY: 'organizationProxy',
  ORGANIZATION_KP_IMPLEMETATION_REPORT: 'kpImplementationReport', // Отчет о реализации КП
  ORGANIZATION_KP_VALIDATION_REPORT: 'kpValidationReport', // Отчет о валидации КП
  ORGANIZATION_KP_AFFILIATION_INFORMATION: 'kpAffiliationInformation', // Сведения об отраслевой принадлежности КП
  ORGANIZATION_KP_VALIDATORS_AND_VERIFIERSINFORMATION: 'kpValidatorsAndVerifiersInformation', // Информация о валидаторах/ верификаторах КП
  ORGANIZATION_KP_ACCREDITATION_VERIFIEDINFORMATION: 'kpAccreditedVerifiedInformation', // Информация об использовании аккредитованной/ верифицированной методике реализации КП
  ORGANIZATION_STATEMENT_OF_ACCOUNT_IN_CARBON_UNUT_REGISTRY: 'statementOfAccountInCarbonUnitsRegistry' // Выписка со счета в Реестре углеродных единиц
})

export const TRADE_DIRECTION_TYPES = Object.freeze({
  RAISING: 'raising',
  LOWERING: 'lowering'
})

export const LOT_REQUEST_TYPES = Object.freeze({
  REGISTRATION: 'registration',
  RECALL: 'recall',
  CHANGE_DOCUMENTS: 'changeDocuments',
  CONTRACT_CONDITION_FAIL: 'contractConditionFail',
  SESSION_REGISTRATION: 'sessionRegistration'
})

export const LOT_ACTIONS = Object.freeze({
  ...LOT_REQUEST_TYPES,
  ADD_ORDERS: 'addOrders',
  DELETE: 'delete',
  TRADE_PROCESS_DOCUMENTATION: 'tradeProcessDocumentation',
  WINNER_SELECT: 'winnerSelect',
  CREATE_TEMPLATE: 'createTemplate'
})

export const TRADE_RESULT_TYPES = Object.freeze({
  UNSET: 'unset',
  FAILED: 'failed',
  WINNER_SELECTED: 'winnerSelected',
  ONE_PARTICIPANT_AGREED: 'oneParticipantAgreed',
  NO_ORGANIZER_OFFER: 'noOrganizerOffer',
  NO_ORDERS: 'noOrders'
})

export const SESSION_LOCK_STATUSES = Object.freeze({
  UNLOCKED: 'unlocked',
  LOCKED_BY_END_SESSION_TIME_MAX: 'lockedByEndSessionTimeMax'
})

export const STATIC_PAGES_TAGS = Object.freeze({
  STATIC_DOCS_TARIFFS: 'static_docs_tariffs',
  STATIC_DOCS_ORG_REGISTRATION: 'static_docs_org_registration',
  STATIC_DOCS_USER_REGISTRATION: 'static_docs_user_registration',
  STATIC_DOCS_GUIDES: 'static_docs_guides',
  STATIC_DOCS_REQUISITES: 'static_docs_requisites',
  STATIC_MAIN_ADMIN: 'static_main_admin',
  STATIC_MAIN: 'static_main',
  STATIC_DIGITAL_SIGNATURE: 'static_digital_signature',
  STATIC_SKZI: 'static_skzi',
  STATIC_SUPPORT: 'static_support'
})

export const TIMER_STATUSES = Object.freeze({
  EXPIRED: 'expired',
  RUNNING: 'running',
  UPCOMING: 'upcoming'
})

export const TIME_UNITS = Object.freeze({
  DAYS: 'days',
  MINUTES: 'minutes',
  HOURS: 'hours',
  SECONDS: 'seconds',
  MILLISECONDS: 'milliseconds'
})

export const CAPTCHA_METHODS = Object.freeze({
  GOOGLE: 'google',
  CAPTCHA_GEN: 'captchaGen'
})

export const FILE_TYPES = Object.freeze({
  XML: 'xml',
  XLSX: 'xlsx'
})
